import { Stack, Typography } from '@mui/material';
import { Booking } from '@thro-types/leihbar';

import { useTranslation } from 'react-i18next';

import { translations } from 'locales/i18n';
import { formatToDateAndTime } from 'utils/dates';

export const ProductCardFooter = ({ booking }: { booking: Booking }) => {
  const { t } = useTranslation();
  return (
    <Stack>
      <Typography>
        {`${t(translations.pages.leihbar.shoppingCart.pickUpTime())}: ${formatToDateAndTime(
          booking.startTime
        )}`}
      </Typography>
      <Typography>
        {`${t(translations.pages.leihbar.shoppingCart.returnTime())}: ${formatToDateAndTime(
          booking.endTime
        )}`}
      </Typography>
      <Typography>
        {`${t(translations.pages.leihbar.article.create.articleId())}: ${booking.article?.sku}`}
      </Typography>
      {booking.comment && (
        <Typography>
          {`${t(translations.pages.leihbar.shoppingCart.comment())}: ${booking.comment}`}
        </Typography>
      )}
      {booking.article?.internalNote && (
        <Typography>
          {`${t(translations.pages.leihbar.internalArticleNote())}: ${
            booking.article?.internalNote
          }`}
        </Typography>
      )}
      {booking.article?.product?.hint && (
        <Typography>
          {`${t(translations.pages.leihbar.product.hint())}: ${booking.article?.product?.hint}`}
        </Typography>
      )}
      {booking.article?.product?.internalNote && (
        <Typography>
          {`${t(translations.pages.leihbar.internalNote())}: ${
            booking.article?.product?.internalNote
          }`}
        </Typography>
      )}
    </Stack>
  );
};
